import React from 'react';
import ListK3 from '../../components/spravochniki/k3/ListK3'

function Page(props) {
    return (
        <>
          <ListK3 />
        </>
    );
}

export default Page;